var _rect, _rect2, _rect3, _mask, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHomeOutline = function SvgHomeOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home-outline",
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 19,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    transform: "translate(-258 -87)",
    fill: "#F2F3F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: -25,
    width: 1180,
    height: 600,
    rx: 16,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_247_12747",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 22,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 17V11.7059H12.8V17H17.3V9.94118H20L11 2L2 9.94118H4.7V17H9.2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 17V11.7059H12.8V17H17.3V9.94118H20L11 2L2 9.94118H4.7V17H9.2Z",
    stroke: "#046FD2",
    strokeWidth: 3,
    strokeLinejoin: "round",
    mask: "url(#path-2-outside-1_247_12747)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHomeOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "home-outline.e6e6348007a31c23160e4ad92dbf87fa.svg";